import { render } from "./ReviewCard.vue?vue&type=template&id=d381637a&scoped=true"
import script from "./ReviewCard.vue?vue&type=script&lang=js"
export * from "./ReviewCard.vue?vue&type=script&lang=js"

import "./ReviewCard.vue?vue&type=style&index=0&id=d381637a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d381637a"]])

export default __exports__